import React, { Component } from 'react'

export default class PageComponent extends Component {
  render() {
    const getComponents = pageComponent => {
      return this.props.components[pageComponent.componentName]
    }

    let TagName = getComponents(this.props.pageComponent)

    return (
      <TagName {...this.props.pageComponent.props} key={this.props.index} />
    )
  }
}
